(function () {

    'use strict';
    angular.module('iplusjs.mapper.identityType', [
        'lodash',
        'iplusjs.utils.misc',
        'iplusjs.utils.identityType'
    ])
    .directive('iplusjsIdentityTypeMapper', identityTypeMapper);

    identityTypeMapper.$inject = [
        'lodash',
        'MiscUtilsService',
        'IdentityTypeUtilsService'
    ];
    function identityTypeMapper(_, MiscUtilsService, IdentityTypeUtilsService) {
        return {
            restrict: 'A',
            require: 'ngModel',
            priority: 1000,
            scope: {
                type: '@iitmType',
                displayValueType: '@iitmDisplayValueType',
                formatOnViewValueChange: '@iitmFormatOnViewValueChange'
            },
            link: function ($scope, $element, $attr, $ngModel) {
                var displayValueType = $scope.displayValueType || 'id';

                function toModel(value) {
                    var val = IdentityTypeUtilsService.create(_.toUpper($scope.type), IdentityTypeUtilsService.toId(value, $scope.type)),
                        formatedValue,
                        isValid = IdentityTypeUtilsService.isValid(value, $scope.type);

                    if ($scope.$eval($scope.formatOnViewValueChange) && MiscUtilsService.isNotEmpty(val)) {
                        formatedValue = IdentityTypeUtilsService.getFormatiert(val);

                        if (value !== formatedValue) {
                            $ngModel.$viewValue = formatedValue;
                            $ngModel.$setViewValue(formatedValue);
                            $ngModel.$commitViewValue();
                            $ngModel.$render();
                        }
                    }

                    return isValid ? val : value;
                }

                function toView(value) {
                    return IdentityTypeUtilsService['get' + _.upperFirst(displayValueType)](value);
                }

                $ngModel.$parsers.push(toModel);
                $ngModel.$formatters.push(toView);
            }
        };
    }
})();
